/* unplugin-vue-components disabled */import script from "./EmptyListPlaceholder.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyListPlaceholder.vue?vue&type=script&setup=true&lang=js"

import "./EmptyListPlaceholder.vue?vue&type=style&index=0&id=6e0aa91b&lang=scss"

const __exports__ = script;

export default __exports__